<template>
	<div id="positionManagement">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->

			<div class="headerContainer">
				<div class="title">职位管理</div>
				<el-button type="primary" @click="postPosition">新增职位</el-button>
				<el-button type="primary" @click="addEnterprise">批量导入</el-button>
				<!-- <el-button type="primary" @click="download1">职位导入模版下载</el-button>
				<el-button type="primary" @click="addEnterprise">批量导入职位</el-button> -->
			</div>

			<div class="listContainer">
				<!-- <div class="title">
					生源列表
				</div> -->
				<div class="screenContainer">
					<div class="searchContainer">
						<div class="searchItem">
							<!-- <div class="iptName">
								职位类型：
							</div> -->
							<el-select v-model="job_type" placeholder="招聘类型">
								<el-option v-for="item in typeList" :key="item.value" :label="item.label"
									:value="item.value"> </el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<!-- <div class="iptName">
								职位薪资：
							</div> -->
							<el-select size="medium" v-model="salary_min" clearable
								:placeholder="`职位薪资${isshow ? '(小值)' : ''}`" @change="changeSalay1">
								<el-option v-for="item in salaryArry1" :key="item.value" :label="item.label"
									:value="item.value"> </el-option>
							</el-select>

							<el-select v-model="salary_max" clearable placeholder="职位薪资（大值）" v-if="isshow"
								style="margin-left: 10px">
								<el-option v-for="item in salaryArry2" :disabled="salaryDisabled" :key="item.value"
									:label="item.label" :value="item.value"> </el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<!-- <div class="iptName">
								最低学历：
							</div> -->
							<el-select v-model="education" multiple placeholder="最低学历">
								<el-option v-for="(item, index) in eduList" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<!-- <div class="iptName">
								招聘人数：
							</div> -->
							<el-input v-model="job_num" type="number" clearable placeholder="招聘人数"  @input="setJobNum"></el-input>
						</div>
						<!-- <div class="searchItem">
							<el-date-picker v-model="end_time_et" :picker-options="pickerOptions" type="date"
								placeholder="截止时间">
							</el-date-picker>
						</div> -->
					</div>

					<div class="btnContainer">
						<div class="btn" style="background: #1e40af" @click="search">
							<!-- <img src="../img/search.png" alt="" /> -->
							<div>筛选</div>
						</div>

						<div class="btn" style="background: #1e40af; margin-left: 10px" @click="reset">
							<!-- <img src="../img/search.png" alt="" /> -->
							<div>重置</div>
						</div>
					</div>
				</div>

				<div class="tableContainer">
					<el-table :data="jobList" border style="width: 100%" @selection-change="handleSelectionChange"
						v-loading="loading" :row-class-name="tableRowClassName">
						
						<el-empty description="暂无职位" slot="empty"></el-empty>
						
						<el-table-column type="selection" fixed> </el-table-column>
						<el-table-column prop="job_type" label="招聘类型">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.job_type | jobType }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="job_name" label="职位名称" >
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.job_name }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="salary" label="职位薪资">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row | salary }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="education" label="最低学历">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.education || '-' }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="job_num" label="招聘人数">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.job_num || '-' }}
								</div>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="work_time" label="工作时间" width="110">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.work_time||'-'}}
								</div>
							</template>
						</el-table-column> -->
						<el-table-column prop="job_end_time" label="招聘截止时间">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.job_end_time || '-' }}
								</div>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="work_freedom" label="休息方式">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.work_freedom||'-'}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="acceptance_of_overtime" label="加班需求">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.acceptance_of_overtime||'-'}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="acceptance_of_outwork" label="出差需求">
							<template slot-scope="scope">
								<div class="">
									{{ scope.row.acceptance_of_outwork||'-'}}
								</div>
							</template>
						</el-table-column> -->
						<el-table-column prop="date11" label="预览" width="110">
							<template slot-scope="scope">
								<div class="preview">
									<!-- <div class="text">
										预览职位
									</div> -->
									<div class="btn" @click="handleClick(scope.row)">预览职位</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="250">
							<template slot-scope="scope">
								<div class="" style="display: flex;align-items: center;">
									
								<el-button class="compile" @click="to(scope.row.id)" type="primary">编辑</el-button>
								<el-button class="compile" v-if="scope.row.sale_status==1" @click="del_job(scope.row)"
									type="info">下架</el-button>
								<el-button class="compile" v-if="scope.row.sale_status==2" @click="del_job1(scope.row)"
									type="primary">上架</el-button>
									
								<div class=""
									style="color: #FFF;background-color: #F56C6C;border-color: #F56C6C;width: 60px;height: 32px;text-align: center;line-height: 32px;font-size: 14px;border-radius: 4px;cursor: pointer;margin-left: 10px;"
									@click="delJob1(scope.row.id)">
									删除
								</div>	
								</div>
								<!-- <el-button class="delete" type="danger" >删除</el-button> -->
								<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
								<el-button type="text" size="small">编辑</el-button> -->
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div class="paging" v-if="jobList&&jobList.length>0">
					<div class="pagingLeft">
						<el-button plain @click="previousPage" v-if="currentpage > 1">上一页</el-button>
						<el-button plain @click="previousPage" disabled v-else>上一页</el-button>
						
						<el-button plain @click="nextPage" :disabled='isNextPage'>下一页</el-button>
						
						<div class="delete" style="margin-left: 10px">
							<el-button type="danger" @click="deleteJobItem" plain>批量删除</el-button>
						</div>
					</div>
					<el-pagination background layout="prev, pager, next" :page-size="pageSizes" :total="total"
						@current-change="currentChange" :current-page="currentpage"> </el-pagination>
				</div>
			</div>
		</div>

		<div class="preview">
			<el-dialog :visible.sync="dialogVisible" :show-close="false" width="550px">
				<div class="elDialog">
					<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">职位预览</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImage">
									<img class="qrcodeImg" :src="qrcodeImg" alt="" />
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
								</div>

								<div class="hite1">扫描<span style="color: #0084ff">识别二维码</span></div>
								<div class="hite2">可在手机上预览职位效果</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>

		<el-dialog title=" " :visible.sync="importData" :before-close="beforeClose" width="498px">
			<div class="p-box" style="margin-top: -20px">
				<!-- <div class="p-title">批量导入职位</div>
        <div class="c-title">通过上传 Excel 文件批量导入职位到系统中</div> -->
				<img class="p-img0" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/08/28/aaa127.png"
					alt="" />
				<!-- <img class="p-img1" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/08/28/aaa119.png" alt=""> -->
				<div class="p-img1-wrap">
					<!-- :data='fileData1' -->
					<el-upload class="upload-demo" :data="getUploadData" drag
						:action="`https://np.sx985.com/v2/pc/importJob`" :on-success="handleAvatarSuccess1"
						:before-upload="beforeUpload" :show-file-list="false">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
					<div class="" v-html="resmessage"></div>
				</div>
				<!-- <div class="p-title">模版与示例</div>
        <div class="flex-h">
          <div class="b-title">下载标准数据模版</div>
          <img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/08/28/aaa123.png" alt="">
        </div>
        <div class="c-title">查看职位示例</div> -->
				<img class="p-img2" @click="download1"
					src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/08/28/aaa125.png" alt="" />
				<img class="p-img3" style="margin-top: 5px"
					src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/08/28/aaa122.png" alt="" />

				<!-- <div class="iptContainer">
					<div class="item">
						<div class="itemTitle">
							身份:
						</div>
						<div class="">
							<el-select v-model="identity" placeholder="请选择">
								<el-option v-for="(item,index) in options1" :key="index" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="itemTitle">
							对接类型:
						</div>
						<div class="">
							<el-select v-model="type" placeholder="请选择">
								<el-option v-for="item in options2" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="itemTitle">
							来源:
						</div>
						<div class="">
							<el-select v-model="source" placeholder="请选择">
								<el-option v-for="item in options4" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
		
				</div> -->
			</div>
		</el-dialog>
	</div>
</template>
<script>
    const config = require('../../WebConfig')
	import { file } from 'jszip'
import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				getUploadData: {
					admin_id: '',
				},
				dialogVisible: false,

				options: [{
						value: '男',
						label: '男',
					},
					{
						value: '女',
						label: '女',
					},
				],
				value: '',
				value1: '',

				total: 0,
				pageSizes: 6,
				currentPage: 1,
				currentpage: 1,

				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()
					},
				},
				jobList: [],
				tableData: [{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
				],

				typeList: [{
						value: '0',
						label: '全部',
					},
					{
						value: '1',
						label: '全职',
					},
					{
						value: '2',
						label: '实习',
					},
					//             , {
					// 	value: '3',
					// 	label: '兼职'
					// },
				],
				// job_type 招聘类型 1校招2实习3兼职
				// salary_min 薪资最小值   示例：5
				// salary_max 薪资最大值  示例：7
				// education 最低学历  json数组，格式如：["博士","本科"]
				// job_num 招聘人数   示例：2
				// end_time_st 截止时间开始  格式如2025-01-01
				// end_time_et 截止时间结束  格式如2025-01-01

				selectList: [],
				eduList: ['大专', '本科', '硕士', '博士'],
				salaryArry1: [],
				salaryArry2: [],
				salaryArry3: [],

				job_type: '', //招聘类型
				education: '', //最低学历
				job_num: '', //招聘人数
				end_time_et: '', //截止时间
				salary_min: '',
				salary_max: '',

				isshow: false,
				salaryDisabled: true,
				qrcodeImg: '',

				loading: false,
				importData: false,

				searchObj: {},
				resmessage: '',
				timer:null,
			}
		},
		filters: {
			jobType(val) {
				switch (val) {
					case 1:
						return '全职'
					case 2:
						return '实习'
					case 3:
						return '兼职'
					default:
						return '全职'
				}
			},
			salary(item) {
				if (item.salary) {
					return item.salary
				} else {
					if (item.salary_min && item.salary_max) {
						return item.salary_min + '-' + item.salary_max + 'K'
					} else if (item.salary_min > 99) {
						return item.salary_min + '-' + item.salary_max
					} else if (item.salary_min && !item.salary_max) {
						return item.salary_min + 'K+'
					} else if (!item.salary_min && item.salary_max) {
						return item.salary_max + 'K'
					} else {
						return item.salary || '面议'
					}
				}
			},
		},
		mounted() {
			this.getmyJobList()
			// this.getQrcode()
			let arr = [{
				label: '面议',
				value: 0,
			}, ]
			for (let i = 1; i < 31; i++) {
				arr.push({
					label: i + 'K',
					value: i,
				})
			}
			// for (let i = 1; i < 15; i++) {
			// 	arr.push({
			// 		label: 30 + (i * 5) + 'K',
			// 		value: 30 + (i * 5),
			// 	})
			// }
			// for (let i = 1; i < 16; i++) {
			// 	arr.push({
			// 		label: 100 + (i * 10) + 'K',
			// 		value: 100 + (i * 10),
			// 	})
			// }
			this.salaryArry1 = arr
			this.salaryArry2 = arr
			this.salaryArry3 = arr
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			//
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			this.getUploadData.admin_id = this.schoolInfo.admin_id
		},
		computed: {
			...mapState({
				nextToken: (state) => state.nextToken,
				userInfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
			}),
			isNextPage() {
				// total
				// pageSizes
				// currentpage
				console.log(this.currentpage)
				console.log(Math.ceil(this.total / this.pageSizes))
				if (this.currentpage == Math.ceil(this.total / this.pageSizes)||Math.ceil(this.total / this.pageSizes)==0) {
					return true
				} else {
					return  false
				}
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.sale_status == 2) {
					console.log(row)
					console.log(rowIndex)
					return 'warning-row';
				}else{
					return 'normal';
				}

			},
			beforeUpload() {},

			handleAvatarSuccess1(res, file) {
				console.log('handleAvatarSuccess1', res)
				if (res.code == 200) {
					this.resmessage = res.data
					this.$message({
						message: '上传成功',
						type: 'success',
					})
					this.importData = false
					this.currentpage = 1
					this.getmyJobList()
				} else {
					this.$message({
						showClose: true,
						message: file.response.msg,
						type: 'error',
					})
				}
			},
			addEnterprise() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.importData = true
			},
			beforeClose() {
				this.importData = false
			},
			download1() {
				location.href = 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/12/07/企业批量导入职位模板.xlsx'
			},
			reset() {
				this.job_type = ''
				this.job_num = ''
				this.salary_min = ''
				this.salary_max = ''
				this.education = ''
				this.currentpage = 1
				this.searchObj = {}
				this.isshow = false
				this.getmyJobList()
			},
			setJobNum(val) {
				if (val == '') {
					this.job_num = ''
				} else if (val < 1) {
					this.job_num = 1
				}
			},
			getQrcode(id) {
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/recruit/jobdetail&id=${id}&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			handleSelectionChange(val) {
				this.selectList = val
			},

			changeSalay1(val) {
				this.salary_max = ''
				if (val == 0) {
					this.isshow = false
				} else {
					this.isshow = true
				}
				let arr = []
				let array = JSON.parse(JSON.stringify(this.salaryArry3))
				arr = array.filter((item) => {
					return item.value > val
				})
				this.salaryDisabled = false
				this.salaryArry2 = arr
			},
			// 防抖处理
			isRequest(duration = 3000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			isDebounce(duration = 500) {
			return new Promise(resolve => {
			  // 如果已有定时器，清除（重新计时）
			  if (this.timer) {
			    clearTimeout(this.timer);
			  }
			    // 开启新定时器
			    this.timer = setTimeout(() => {
			      resolve(); // 时间到 → 放行
			    }, duration);
			  });
			},
			async deleteJobItem() {
				if (await this.isDebounce()) return; 
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				if (this.selectList.length === 0) {
					this.$message({
						message: '请先选择删除项',
						type: 'error',
					})
					return
				}
				this.$confirm('确定要删除这些职位吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: true,
						type: 'warning',
						closeOnClickModal: false,
						closeOnPressEscape: false,
						cancelButtonClass: 'cancelButtonClass',
						confirmButtonClass: 'confirmButtonClass',
					})
					.then(async () => {
						let isSuccess = true
						for (const item of this.selectList) {
							let res = await this.delJob2(item.id)
							if (!res) {
								isSuccess = res
							}
						}
						console.log(isSuccess)
						if (isSuccess) {
							this.$message({
								message: '职位已删除',
								type: 'success',
							})
						} else {
							this.$message.error('已关联双选会的职位暂不支持删除。')
						}
						// this.selectList.forEach((item) => {
						// 	this.delJob2(item.id)
						this.getmyJobList()
						// })

					})
					.catch((err) => {
						console.log(err)
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消删除',
						// })

					})
			},
			delJob2(job_id) {
				return new Promise((resolve, reject) => {
					if (this.total % 6 == 1 && this.currentpage != 1) {
						this.currentpage = this.currentpage - 1
					}
					this.$util.post(
						'v2/pc/delJob', {
							admin_id: this.schoolInfo.admin_id,
							job_id: job_id,
						},
						(res) => {
							if (res.code == 0) {
								resolve(true)
							} else {
								resolve(false)
							}
						}
					)
				})
			},


			delJob1(id) {
				this.$confirm('确定要删除这个职位吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: true,
						type: 'warning',
						closeOnClickModal: false,
						closeOnPressEscape: false,
						cancelButtonClass: 'cancelButtonClass',
						confirmButtonClass: 'confirmButtonClass',
					})
					.then(() => {
						this.delJob(id)
					})
					.catch((aaa) => {
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消删除',
						// })
					})
			},



			delJob(job_id) {
				if (this.total % 6 == 1 && this.currentpage != 1) {
					this.currentpage = this.currentpage - 1
				}
				this.$util.post(
					'v2/pc/delJob', {
						admin_id: this.schoolInfo.admin_id,
						job_id: job_id,
					},
					(res) => {
						if (res.code == 0) {
							setTimeout(() => {
								this.getmyJobList()
							}, 100)
						} else {
							this.$message.error(res.msg)
						}
					}
				)
			},

			search() {
				// job_num
				// if(this.job_num>10000)
				let obj = {
					job_type: this.job_type,
					job_num: this.job_num,
				}
				if (this.salary_min == 0) {
					obj.salary_min = 0
					obj.salary_max = 0
				} else {
					obj.salary_min = this.salary_min
					obj.salary_max = this.salary_max
					if (!this.salary_min || !this.salary_max) {
						this.$message({
							message: '请正确选择薪资范围进行筛选',
							type: 'error',
						})
						return
					}
				}
				if (this.education !== '') {
					obj.education = JSON.stringify(this.education)
				}

				this.searchObj = obj
				this.currentpage = 1
				this.getmyJobList()
				// this.$message({
				// 	message: '加载成功',
				// 	type: 'success'
				// });
			},

			getmyJobList() {
				this.loading = true
				this.$util.post(
					'v2/pc/my_job_list', {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
						page: this.currentpage,
						size: 6,
						...this.searchObj,

					},
					(res) => {
						console.log(res)
						if (res.code == 200) {
							this.jobList = res.data.data
							this.total = res.data.meta.total
						}
						this.loading = false
					},(err)=>{
						console.log(err)
						this.loading = false
					}
				)
			},
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
				switch (status) {
					case 0:
						return Y + M + D
					case 1:
						return Y + M + D + H + Minu + S
					default:
						break
				}
			},
			getTime(dateTimeString) {
				const dateTime = new Date(dateTimeString)
				const year = dateTime.getUTCFullYear()
				const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0')
				const day = String(dateTime.getUTCDate()).padStart(2, '0')
				// const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				// const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				// const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				const formattedDateTime = `${year}-${month}-${day}`

				return formattedDateTime
			},

			postPosition() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				this.$router.push({
					path: '/addPosition',
					// query: {
					//   id: 1,
					// },
				})
			},
			to(id) {
				this.$router.push({
					path: '/addPosition',
					query: {
						id: id,
					},
				})
			},
			del_job(row) {
				this.$confirm('确定下架当前职位吗?', '提示', {
						confirmButtonspan: '确定',
						cancelButtonspan: '取消',
						closeOnClickModal: false,
						type: 'warning',
					})
					.then(() => {
						this.$util.post(
							'v2/school_job/del_job', {
								id: row.id,
								sale_status: row.sale_status == 1 ? 2 : 1,
							},
							(res) => {
								if (res.code == 0) {
									this.$message({
										message: '职位已下架',
										type: 'success',
									})
									setTimeout(() => {
										this.getmyJobList()
									}, 100)
								} else {
									this.$message({
										message: res.msg,
										type: 'error',
									})
								}
							}
						)

					})
					.catch(() => {

					})
			},
			del_job1(row) {
				this.$confirm('确定上架当前职位吗?', '提示', {
						confirmButtonspan: '确定',
						cancelButtonspan: '取消',
						closeOnClickModal: false,
						type: 'warning',
					})
					.then(() => {
						this.$util.post(
							'v2/school_job/del_job', {
								id: row.id,
								sale_status: row.sale_status == 1 ? 2 : 1,
							},
							(res) => {
								if (res.code == 0) {
									this.$message({
										message: '职位已上架',
										type: 'success',
									})
									setTimeout(() => {
										this.getmyJobList()
									}, 100)
								} else {
									this.$message({
										message: res.msg,
										type: 'error',
									})
								}
							}
						)

					})
					.catch(() => {

					})
			},
			handleClick(row) {
				this.getQrcode(row.id)
				this.dialogVisible = true
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			closeElDialog() {
				this.dialogVisible = false
			},

			currentChange(page) {
				this.currentpage = page
				// this.currentpage = page
				// this.getEnterpriseList()
				this.getmyJobList()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage = this.currentpage - 1
					this.getmyJobList()
				}
			},
			nextPage() {
				if(!this.isNextPage){
					this.currentpage++
					this.getmyJobList()
				}
			},
		},
		components: {},
	}
</script>
<style>
	/* #positionManagement .el-table .warning-row {
		background-color: #FEE2E2 ;
	} */
	#positionManagement .el-table .normal {
		background: #f9fbff;
	}

	.confirmButtonClass {
		background: #fff !important;
		color: #606266 !important;
		border: 1px solid #dcdfe6 !important;
	}

	.cancelButtonClass {
		color: #fff !important;
		background-color: #1e40af !important;
		border-color: #1e40af !important;
	}

	#positionManagement .el-table--border .el-table__cell:first-child .cell {
		padding-left: 10px !important;
		padding-right: 10px !important;
	}

	#positionManagement .el-upload-dragger {
		width: 458px !important;
		height: 224px !important;
	}

	#positionManagement .searchContainer .el-select {
		min-width: 175px !important;
		width: 100% !important;
		/* max-width: 265px !important; */
	}

	/* #positionManagement .searchContainer .el-input__inner {
		background-color: #F0F4FA !important;
		color: #000;
	}
	
	#positionManagement .searchContainer .el-tag.el-tag--info {
		background: #fff !important;
		border-color: #fff;
	}
	
	#positionManagement .searchContainer .el-input__inner::-moz-placeholder {
		color: #000;
	}
	
	#positionManagement .searchContainer .el-input__inner::-ms-input-placeholder {
		color: #000;
	}
	
	#positionManagement .searchContainer .el-input__inner::-webkit-input-placeholder {
		color: #000;
	} */

	#positionManagement .searchContainer .el-date-editor {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	#positionManagement .searchContainer .el-date-editor {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	#positionManagement .searchContainer .el-input {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	.listContainer .el-table .cell {
		text-align: center !important;
	}

	.listContainer .el-table__header th {
		background: #e9eeff;
		font-weight: bold !important;
		color: #2a2929 !important;
	}

	/* .listContainer .el-table__body td {
		background: #f9fbff;
	} */

	/* .tableContainer .compile .el-button--primary {
		background-color: #4F8FF0;
		border-color: #4F8FF0;
	} */

	.tableContainer .delete .el-button--primary {
		background-color: #dc7777;
		border-color: #dc7777;
	}

	#positionManagement .preview .el-dialog {
		background: initial;
		box-shadow: initial;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.headerContainer {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #eeeeee;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.el-button--primary {
				font-size: 14px !important;
				// background-color: #0084FF !important;
				// border-color: #0084FF !important;
			}
		}

		.listContainer {
			// padding: 0 40px;

			// .title {
			// 	font-weight: bold;
			// 	font-size: 18px;
			// 	color: #2D3C50;
			// 	margin-bottom: 20px;
			// 	margin-left: 8px;
			// }

			.screenContainer {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
			}

			.searchContainer {
				flex: 1;
				// padding-left: 8px;
				// display: flex;
				// align-items: center;
				// flex-wrap: wrap;

				display: grid;
				grid-template-columns: repeat(4, 1fr);
				grid-gap: 10px 10px;
				margin-right: 20px;

				.searchItem {
					// flex: 1;
					// width: 100%;
					display: flex;
					align-items: center;
					// margin-right: 10px;
					// margin-bottom: 10px;

					.iptName {
						width: 75px;
						text-align: right;
						font-weight: 400;
						font-size: 14px;
						color: #333;
					}
				}
			}

			.btnContainer {
				display: flex;
				align-items: center;
				padding-right: 15px;

				.btn {
					width: 92px;
					height: 39px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #fd8342;
					border-radius: 5px;
					font-size: 0;
					cursor: pointer;

					img {
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}

					div {
						font-weight: 400;
						font-size: 14px;
						color: #ffffff;
					}
				}
			}

			.tableContainer {
				width: 100%;
			}
		}
	}

	.preview {
		.text {
			font-weight: 400;
			font-size: 14px;
			color: #2a2929;
			// margin-bottom: 5px;
		}

		.btn {
			font-weight: 400;
			font-size: 14px;
			color: #004eff;
			cursor: pointer;
		}
	}

	.paging {
		width: 100%;
		padding: 20px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.pagingLeft {
			display: flex;
			align-items: center;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 50px;
			// width: 410px;
			// height: 390px;
			background: #ffffff;
			border-radius: 10px;
			border: 4px solid #0084ff;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImage {
				position: relative;
				width: 208px;
				height: 245px;
			}

			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}

			.qrcodeLogo {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				width: 90px;
				height: 90px;
				border-radius: 50%;
				margin: 58px auto;
			}

			.hite1 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #ffffff;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #eeeeee;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2d3c50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #aeaeae;
					font-weight: 500;
					font-size: 12px;
					color: #aeaeae;
					margin-right: 5px;
				}
			}
		}
	}

	.p-box {
		.p-title {
			font-size: 18px;
			color: #000;
			font-weight: 500;
		}

		.c-title {
			font-size: 14px;
			color: #000;
			opacity: 0.6;
		}

		.p-img1-wrap {
			display: block;
			width: 572 * 0.8px;
			height: 280 * 0.8px;
			background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/08/28/aaa119.png') no-repeat;
			background-size: 100% 100%;

			.upload-demo {
				opacity: 0;
				height: 280 * 0.8px;

				.el-upload-dragger {
					height: 280 * 0.8px !important;
				}
			}
		}

		.p-img3 {
			display: block;
			width: 572 * 0.8px;
			height: 280 * 0.8px;
		}

		.p-img0 {
			display: block;
			width: 572 * 0.8px;
			height: 68 * 0.8px;
		}

		.p-img2 {
			display: block;
			width: 572 * 0.8px;
			height: 138 * 0.8px;
			cursor: pointer;
		}
	}
</style>
